import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { LinkedService } from './linkedservice';
import { ModelConstants } from '../model-constants';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.powerBIWorkspaceLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.PowerBI),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.PowerBI)
    ]
})
export class PowerBIWorkspaceLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_PowerBIWorkspaceID
    })
    public workspaceID?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Tenant
    })
    public tenantID?: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
